import { Col, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import { ListAreasQuery } from '@/core/domain/operational/Areas/Areas.types';

function AreasExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListAreasQuery>) {
  return (
    <Row gutter={[16, 16]} align="middle">
      <Col xs={24} sm={24} md={8} xl={4}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default AreasExtraFilters;
